import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, MailIcon } from 'lucide-react';
export function OfferSection() {
  return <AnimatedSection className="py-16 md:py-24 px-6 max-w-3xl mx-auto" data-id="element-243">
      <div id="offer" className="bg-cream rounded-3xl p-8 md:p-12 border-2 border-sage/20 text-center relative overflow-hidden scroll-mt-8" data-id="element-244">
        {/* Decorative background elements */}
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-sage/10 rounded-full blur-3xl" data-id="element-245"></div>
        <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-terracotta/10 rounded-full blur-3xl" data-id="element-246"></div>

        <div className="relative z-10" data-id="element-247">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-248">
            Recupera tu paz hoy mismo.
          </h2>
          <p className="text-lg text-charcoal/70 mb-8 max-w-xl mx-auto" data-id="element-249">
            El acceso al Protocolo Completo "Controla tu Ansiedad" (Audio + Guía
            PDF + Bonus) está disponible por un pago único.
          </p>

          {/* Product Image */}
          <motion.div className="max-w-sm mx-auto mb-8" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6
        }} viewport={{
          once: true
        }} data-id="element-250">
            <img src="https://cdn.magicpatterns.com/uploads/3nvjHQsXpTPjstsmtLphnQ/heylloyd-image-1772728770119.png" alt="Controla tu Ansiedad - PDF eBook y Audio guía" className="w-full h-auto rounded-xl shadow-lg" data-id="element-251" />
          </motion.div>

          <div className="py-6 border-t border-b border-charcoal/10 mb-8" data-id="element-252">
            <div className="text-6xl font-bold text-charcoal font-heading mb-2" data-id="element-253">
              $19{' '}
              <span className="text-2xl text-charcoal/60 font-body" data-id="element-254">USD</span>
            </div>
            <p className="text-charcoal/60" data-id="element-255">
              Menos de lo que cuesta una salida a comer, para una herramienta
              que llevarás en tu bolsillo siempre.
            </p>
          </div>

          <CTAButton text="Sí, Quiero Controlar Mi Ansiedad Ahora" className="mb-6" href="https://www.elevaemily.com/products/controla-la-ansiedad" data-id="element-256" />

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-charcoal/70 text-sm" data-id="element-257">
            <div className="flex items-center gap-2" data-id="element-258">
              <ShieldCheckIcon className="w-5 h-5 text-sage" data-id="element-259" />
              <span data-id="element-260">Compra segura</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-261">
              <MailIcon className="w-5 h-5 text-sage" data-id="element-262" />
              <span data-id="element-263">Acceso instantáneo por correo electrónico</span>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}